var parts = ["slider", "slide", "dotNav", "thumb", "arrowNav", "container"];
var baseStyle = {
  container: {
    position: "relative",
    w: "full",
    overflow: "hidden"
  },
  slider: {
    overflowX: "visible",
    display: "flex",
    listStyle: "none",
    w: "full",
    m: 0,
    flexWrap: "nowrap",
    scrollBehavior: "smooth",
    alignItems: "center",
    justifyContent: "flex-start"
  },
  slide: {
    flexShrink: 0,
    height: "full",
    overflow: "hidden"
  },
  dotNav: {
    display: "flex",
    listStyle: "none",
    justifyContent: "center",
    "& button": {
      borderRadius: "50%",
      w: 2,
      h: 2,
      bg: "gray.100",
      mx: 2.5,
      "&:active, &.active": {
        bg: "gray.300"
      }
    }
  },
  thumb: {
    height: "full"
  },
  arrowNav: {
    "& > button": {
      color: "white",
      position: "absolute",
      h: "14",
      w: "7",
      transform: "translateY(-50%)"
    },
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    w: "full",
    overflow: "visible",
    h: "0"
  }
};
var variants = {};
var sizes = {};
export default {
  parts,
  baseStyle,
  variants,
  sizes
};
//# sourceMappingURL=carousel.js.map